"use client"

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useTranslations } from "next-intl"


/**
 * Matrix view mode — mirrors the Product Economics (config) tab's modes.
 * `all` + `custom` both fetch in SKU `groupBy`; `custom` narrows the rows
 * client-side by the picked products. `family` fetches in family `groupBy`.
 */
export type MatrixViewMode = "all" | "custom" | "family"

interface BundleMatrixModeToggleProps {
  value: MatrixViewMode
  onChange: (value: MatrixViewMode) => void
}

export function BundleMatrixModeToggle({ value, onChange }: BundleMatrixModeToggleProps) {
  const tUi = useTranslations("Shopify.ShopifyEconomicsBundleMatrixModeToggle")

  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as MatrixViewMode)}>
      <TabsList>
        <TabsTrigger value="all"><span key={tUi("allProducts")}>{tUi("allProducts")}</span></TabsTrigger>
        <TabsTrigger value="family"><span key={tUi("family")}>{tUi("family")}</span></TabsTrigger>
        <TabsTrigger value="custom"><span key={tUi("customSelection")}>{tUi("customSelection")}</span></TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
